// Número do WhatsApp Business da Doce Casa (formato internacional, sem "+" nem espaços).
export const WHATSAPP_NUMBER = "351925581930";

export const WHATSAPP_GREETING =
  "Olá, seja bem-vindo(a) à minha cozinha, o que deseja encomendar hoje?";

export const whatsappLink = (message = WHATSAPP_GREETING) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const orderMessage = (doce) =>
  `${WHATSAPP_GREETING} Gostava de encomendar: ${doce}.`;

export const WHATSAPP_URL = whatsappLink();

export const BRAND = {
  name: "Doce Casa",
  slogan: "Um doce com cheirinho de casa.",
  area: "Amadora, Grande Lisboa e arredores",
};
